import script from "./MaterialT.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialT.vue?vue&type=script&setup=true&lang=ts"

import "./MaterialT.vue?vue&type=style&index=0&id=512643cd&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-512643cd"]])

export default __exports__